import React, { useState, useEffect } from "react";
import DateFnsUtils from "@date-io/date-fns";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { AiOutlineSearch } from "react-icons/ai";

const DatePicker = ({ date, setDate, setSearch, search }) => {
    const [error, setError] = useState({ from: "", to: "" });

    useEffect(() => {
        date && date?.from && date?.from > new Date().setHours(23, 59, 59, 999).valueOf()
            ? setError({ ...error, from: "Please enter valid date" })
            : setError({ ...error, from: "" });
        date && date?.to && date?.to > new Date().setHours(23, 59, 59, 999).valueOf()
            ? setError({ ...error, to: "Please enter valid date" })
            : setError({ ...error, to: "" });
        date && date?.from && date?.to && date?.from > date?.to
            ? setError({ ...error, from: "from date should be less then to date" })
            : setError({ ...error, from: "" });
    }, [date]);

    const handleSearch = () => {
        if (error?.from === "" && error?.to === "") {
            setSearch(true);
        }
    };

    return (
        <div className="flexCol">
            <div className="flexRow alignCenter">
                <div className="pdngXS">
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                            fullWidth
                            className="pickerInput"
                            inputVariant="outlined"
                            value={date?.from}
                            onChange={(d) => setDate({ ...date, from: new Date(d).setHours(0, 0, 0, 0).valueOf() })}
                            animateYearScrolling
                            placeholdertext="from"
                            format="dd/MM/yyyy"
                            maxDate={new Date()}
                        />
                    </MuiPickersUtilsProvider>
                </div>
                <div className="pdngXS">
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                            fullWidth
                            className="pickerInput"
                            inputVariant="outlined"
                            value={date?.to}
                            onChange={(d) => setDate({ ...date, to: new Date(d).setHours(23, 59, 59, 998).valueOf() })}
                            animateYearScrolling
                            placeholdertext="to"
                            format="dd/MM/yyyy"
                            maxDate={new Date()}
                        />
                    </MuiPickersUtilsProvider>
                </div>
                <div className={error?.from === "" && error?.to === "" && !search ? "pdngXS" : "disableMode pdngXS"}>
                    <div className="pdngXXXS brdrSM" onClick={handleSearch}>
                        <AiOutlineSearch style={{ fontSize: "26px" }} />
                    </div>
                </div>
            </div>
            <div className="flexCol alignCenter">
                {error && error?.from && error?.from !== "" && <span className="inputErrorMsg">{error?.from}</span>}
                {error && error?.to && error?.to !== "" && <span className="inputErrorMsg">{error?.to}</span>}
            </div>
        </div>
    );
};
export default DatePicker;
